import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography } from '@mui/material';

export default function PromptNode({ data, selected }) {
  const color = data.promptType === 'base' ? '#78909c' : '#e8922a';

  return (
    <Box
      sx={{
        position: 'relative',
        border: `2px solid ${color}`,
        borderRadius: 2,
        width: 260,
        bgcolor: 'background.paper',
        boxShadow: selected ? `0 0 0 3px ${color}44` : 1,
      }}
    >
      <Handle id="target-top" type="target" position={Position.Top} style={{ background: color }} />
      <Handle id="target-left" type="target" position={Position.Left} style={{ background: color }} />
      <Handle id="source-bottom" type="source" position={Position.Bottom} style={{ background: color }} />
      <Handle id="source-right" type="source" position={Position.Right} style={{ background: color }} />
      <Box
        sx={{
          px: 1.5,
          py: 0.75,
          bgcolor: `${color}22`,
          borderRadius: '6px 6px 0 0',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography sx={{ color, fontSize: 14 }}>◈</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color, fontSize: 11, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {data.label || 'Prompt'}
        </Typography>
      </Box>
      <Box sx={{ px: 1.5, py: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: 10,
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {data.content || 'Click to edit prompt...'}
        </Typography>
      </Box>
    </Box>
  );
}
